/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListDocumentsQueryVariables = Types.Exact<{
  input: Types.GetDocumentsInput;
}>;


export type ListDocumentsQuery = { __typename?: 'Query', listDocuments: Array<{ __typename?: 'DocumentModel', created_at?: string | null, description?: string | null, document_id: string, name?: string | null, s3_key?: string | null, status_id?: string | null, uploaded: boolean, vitall_patient_id?: string | null, status?: { __typename?: 'StatusModel', color?: string | null, model: Types.StatusType, public_name: string, status_id: string } | null }> };

export type GetDocumentDownloadUrlQueryVariables = Types.Exact<{
  input: Types.GetDocumentInput;
  previewable?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetDocumentDownloadUrlQuery = { __typename?: 'Query', getDocumentRecord: { __typename?: 'DocumentModel', document_id: string, name?: string | null, downloadUrl?: { __typename?: 'GetDownloadUrlResponse', url?: string | null, status: Types.DocumentHealthStatus } | null } };

export type UploadClientRecordsMutationVariables = Types.Exact<{
  input: Types.PostDocumentsInput;
}>;


export type UploadClientRecordsMutation = { __typename?: 'Mutation', uploadClientRecords: Array<{ __typename?: 'DocumentModel', document_id: string, name?: string | null, s3_key?: string | null, status_id?: string | null, uploaded: boolean, vitall_patient_id?: string | null, uploadData: { __typename?: 'MultipartUploadModel', isMultipart: boolean, multipartUploadId?: string | null, parts: Array<{ __typename?: 'PartModel', part: number, presigned_url: string }>, expectedHeaders?: { __typename?: 'ExpectedUploadHeaders', contentType: string, contentDisposition: string } | null } }> };

export type UploadImportJobCsvMutationVariables = Types.Exact<{
  input: Types.UploadImportJobCsvInput;
}>;


export type UploadImportJobCsvMutation = { __typename?: 'Mutation', uploadImportJobCsv: { __typename?: 'DocumentModel', document_id: string, name?: string | null, s3_key?: string | null, uploaded: boolean, uploadData: { __typename?: 'MultipartUploadModel', isMultipart: boolean, multipartUploadId?: string | null, parts: Array<{ __typename?: 'PartModel', part: number, presigned_url: string }>, expectedHeaders?: { __typename?: 'ExpectedUploadHeaders', contentType: string, contentDisposition: string } | null } } };

export type SetDocumentsUploadedMutationVariables = Types.Exact<{
  input: Types.SetDocumentsUploadedInput;
}>;


export type SetDocumentsUploadedMutation = { __typename?: 'Mutation', setDocumentsUploaded: Array<{ __typename?: 'DocumentModel', created_at?: string | null, description?: string | null, document_id: string, name?: string | null, s3_key?: string | null, size: number, status_id?: string | null, uploaded: boolean, vitall_patient_id?: string | null }> };

export type UpdateDocumentRecordMutationVariables = Types.Exact<{
  input: Types.UpdateDocumentInput;
}>;


export type UpdateDocumentRecordMutation = { __typename?: 'Mutation', updateDocumentRecord: { __typename?: 'UpdateDocumentResponse', message: string, success: boolean, data?: { __typename?: 'DocumentModel', document_id: string, status_id?: string | null, name?: string | null } | null } };


export const ListDocumentsDocument = gql`
    query listDocuments($input: GetDocumentsInput!) {
  listDocuments(input: $input) {
    created_at
    description
    document_id
    name
    s3_key
    status_id
    status {
      color
      model
      public_name
      status_id
    }
    uploaded
    vitall_patient_id
  }
}
    `;
export function useListDocumentsQuery(baseOptions: Apollo.QueryHookOptions<ListDocumentsQuery, ListDocumentsQueryVariables> & ({ variables: ListDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDocumentsQuery, ListDocumentsQueryVariables>(ListDocumentsDocument, options);
      }
export function useListDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDocumentsQuery, ListDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDocumentsQuery, ListDocumentsQueryVariables>(ListDocumentsDocument, options);
        }
// @ts-ignore
export function useListDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListDocumentsQuery, ListDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<ListDocumentsQuery, ListDocumentsQueryVariables>;
export function useListDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDocumentsQuery, ListDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<ListDocumentsQuery | undefined, ListDocumentsQueryVariables>;
export function useListDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDocumentsQuery, ListDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListDocumentsQuery, ListDocumentsQueryVariables>(ListDocumentsDocument, options);
        }
export type ListDocumentsQueryHookResult = ReturnType<typeof useListDocumentsQuery>;
export type ListDocumentsLazyQueryHookResult = ReturnType<typeof useListDocumentsLazyQuery>;
export type ListDocumentsSuspenseQueryHookResult = ReturnType<typeof useListDocumentsSuspenseQuery>;
export type ListDocumentsQueryResult = Apollo.QueryResult<ListDocumentsQuery, ListDocumentsQueryVariables>;
export const GetDocumentDownloadUrlDocument = gql`
    query getDocumentDownloadUrl($input: GetDocumentInput!, $previewable: Boolean = false) {
  getDocumentRecord(input: $input) {
    document_id
    name
    downloadUrl(previewable: $previewable) {
      url
      status
    }
  }
}
    `;
export function useGetDocumentDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentDownloadUrlQuery, GetDocumentDownloadUrlQueryVariables> & ({ variables: GetDocumentDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentDownloadUrlQuery, GetDocumentDownloadUrlQueryVariables>(GetDocumentDownloadUrlDocument, options);
      }
export function useGetDocumentDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentDownloadUrlQuery, GetDocumentDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentDownloadUrlQuery, GetDocumentDownloadUrlQueryVariables>(GetDocumentDownloadUrlDocument, options);
        }
// @ts-ignore
export function useGetDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentDownloadUrlQuery, GetDocumentDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentDownloadUrlQuery, GetDocumentDownloadUrlQueryVariables>;
export function useGetDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentDownloadUrlQuery, GetDocumentDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentDownloadUrlQuery | undefined, GetDocumentDownloadUrlQueryVariables>;
export function useGetDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentDownloadUrlQuery, GetDocumentDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentDownloadUrlQuery, GetDocumentDownloadUrlQueryVariables>(GetDocumentDownloadUrlDocument, options);
        }
export type GetDocumentDownloadUrlQueryHookResult = ReturnType<typeof useGetDocumentDownloadUrlQuery>;
export type GetDocumentDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetDocumentDownloadUrlLazyQuery>;
export type GetDocumentDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useGetDocumentDownloadUrlSuspenseQuery>;
export type GetDocumentDownloadUrlQueryResult = Apollo.QueryResult<GetDocumentDownloadUrlQuery, GetDocumentDownloadUrlQueryVariables>;
export const UploadClientRecordsDocument = gql`
    mutation uploadClientRecords($input: PostDocumentsInput!) {
  uploadClientRecords(input: $input) {
    document_id
    name
    s3_key
    status_id
    uploaded
    vitall_patient_id
    uploadData {
      isMultipart
      multipartUploadId
      parts {
        part
        presigned_url
      }
      expectedHeaders {
        contentType
        contentDisposition
      }
    }
  }
}
    `;
export type UploadClientRecordsMutationFn = Apollo.MutationFunction<UploadClientRecordsMutation, UploadClientRecordsMutationVariables>;
export function useUploadClientRecordsMutation(baseOptions?: Apollo.MutationHookOptions<UploadClientRecordsMutation, UploadClientRecordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadClientRecordsMutation, UploadClientRecordsMutationVariables>(UploadClientRecordsDocument, options);
      }
export type UploadClientRecordsMutationHookResult = ReturnType<typeof useUploadClientRecordsMutation>;
export type UploadClientRecordsMutationResult = Apollo.MutationResult<UploadClientRecordsMutation>;
export type UploadClientRecordsMutationOptions = Apollo.BaseMutationOptions<UploadClientRecordsMutation, UploadClientRecordsMutationVariables>;
export const UploadImportJobCsvDocument = gql`
    mutation uploadImportJobCsv($input: UploadImportJobCsvInput!) {
  uploadImportJobCsv(input: $input) {
    document_id
    name
    s3_key
    uploaded
    uploadData {
      isMultipart
      multipartUploadId
      parts {
        part
        presigned_url
      }
      expectedHeaders {
        contentType
        contentDisposition
      }
    }
  }
}
    `;
export type UploadImportJobCsvMutationFn = Apollo.MutationFunction<UploadImportJobCsvMutation, UploadImportJobCsvMutationVariables>;
export function useUploadImportJobCsvMutation(baseOptions?: Apollo.MutationHookOptions<UploadImportJobCsvMutation, UploadImportJobCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadImportJobCsvMutation, UploadImportJobCsvMutationVariables>(UploadImportJobCsvDocument, options);
      }
export type UploadImportJobCsvMutationHookResult = ReturnType<typeof useUploadImportJobCsvMutation>;
export type UploadImportJobCsvMutationResult = Apollo.MutationResult<UploadImportJobCsvMutation>;
export type UploadImportJobCsvMutationOptions = Apollo.BaseMutationOptions<UploadImportJobCsvMutation, UploadImportJobCsvMutationVariables>;
export const SetDocumentsUploadedDocument = gql`
    mutation setDocumentsUploaded($input: SetDocumentsUploadedInput!) {
  setDocumentsUploaded(input: $input) {
    created_at
    description
    document_id
    name
    s3_key
    size
    status_id
    uploaded
    vitall_patient_id
  }
}
    `;
export type SetDocumentsUploadedMutationFn = Apollo.MutationFunction<SetDocumentsUploadedMutation, SetDocumentsUploadedMutationVariables>;
export function useSetDocumentsUploadedMutation(baseOptions?: Apollo.MutationHookOptions<SetDocumentsUploadedMutation, SetDocumentsUploadedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDocumentsUploadedMutation, SetDocumentsUploadedMutationVariables>(SetDocumentsUploadedDocument, options);
      }
export type SetDocumentsUploadedMutationHookResult = ReturnType<typeof useSetDocumentsUploadedMutation>;
export type SetDocumentsUploadedMutationResult = Apollo.MutationResult<SetDocumentsUploadedMutation>;
export type SetDocumentsUploadedMutationOptions = Apollo.BaseMutationOptions<SetDocumentsUploadedMutation, SetDocumentsUploadedMutationVariables>;
export const UpdateDocumentRecordDocument = gql`
    mutation updateDocumentRecord($input: UpdateDocumentInput!) {
  updateDocumentRecord(input: $input) {
    data {
      document_id
      status_id
      name
    }
    message
    success
  }
}
    `;
export type UpdateDocumentRecordMutationFn = Apollo.MutationFunction<UpdateDocumentRecordMutation, UpdateDocumentRecordMutationVariables>;
export function useUpdateDocumentRecordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentRecordMutation, UpdateDocumentRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentRecordMutation, UpdateDocumentRecordMutationVariables>(UpdateDocumentRecordDocument, options);
      }
export type UpdateDocumentRecordMutationHookResult = ReturnType<typeof useUpdateDocumentRecordMutation>;
export type UpdateDocumentRecordMutationResult = Apollo.MutationResult<UpdateDocumentRecordMutation>;
export type UpdateDocumentRecordMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentRecordMutation, UpdateDocumentRecordMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useListDocuments = withQueryResponseHandler(useListDocumentsQuery);
export const useGetDocumentDownloadUrl = withQueryResponseHandler(useGetDocumentDownloadUrlQuery);
export const useUploadClientRecords = withMutationResponseHandler(useUploadClientRecordsMutation, "uploadClientRecords");
export const useUploadImportJobCsv = withMutationResponseHandler(useUploadImportJobCsvMutation, "uploadImportJobCsv");
export const useSetDocumentsUploaded = withMutationResponseHandler(useSetDocumentsUploadedMutation, "setDocumentsUploaded");
export const useUpdateDocumentRecord = withMutationResponseHandler(useUpdateDocumentRecordMutation, "updateDocumentRecord");